import React from 'react';
import { JBButton } from '@jbhi-fi/lanyard-ui';

type LanyardButtonProps = Parameters<typeof JBButton>[0];

export type AlignedButtonProps = LanyardButtonProps & {
  alignment?: 'Left' | 'Right' | 'Centred';
};

export const AlignedButton = ({ alignment = 'Left', ...buttonProps }: AlignedButtonProps) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: alignment === 'Centred' ? 'center' : alignment === 'Right' ? 'end' : 'start',
      }}
    >
      <JBButton {...buttonProps} />
    </div>
  );
};
